<section class="content profile-page">
  <div class="block-header">
      <div class="">
           <div class="row ">
             <div class="col-md-12 p-0">
              <h2 class="poppins font-weight-bold pl-2">  Customer VirtualAccount </h2>
             </div>
                <div class=" col-md-4 px-6 col-sm-12 p-0">

                   <div class="breadcrumb flat">
                    <a [routerLink]="['/home']">Home</a>
                    <a href="#" class="active">Manage Customer VirtualAccount</a>
                  </div>
                 </div>
                <div class="col-md-8">
                  <div class="float-right">

                    <button   class="box-button mr-3"  type="button" id="NewPrepaidCard" [routerLink]="['/PayOut/VirtualAccount']"
                    color="primary" matTooltip="New PrepaidCard"> New Customer VirtualAccount</button>





                     <div class="dropdown d-inline">
                      <button class="box-button mr-3" type="button" data-toggle="dropdown">Download  &nbsp;<i class="fas fa-caret-down"></i>
                      </button>
                      <ul class="dropdown-menu text-center">
                        <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()" >Excel</a></li>

                      </ul>
                    </div>
                    <!-- <div class="dropdown d-inline">
                      <button class="box-button mr-3" type="button" data-toggle="dropdown">Export as  &nbsp;<i class="fas fa-caret-down"></i>
                      </button>
                      <ul class="dropdown-menu text-center">
                        <li><a href="" id="btnExportBatch" (click)="readAndExportToExcelData()" >Excel</a></li>

                      </ul>
                    </div>
                    <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
                    aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
                  -->
                  <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
                  aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
                  </div>
              </div>
              <div class="col-md-12">
                <small class="mr-3">Here are the results from the past week. Please click on the filter for other results. </small>
              </div>
          </div>
      </div>

  </div>
  <div class="  ">
    <div class="row pb-5"  *ngIf="filtering">
        <div class="col-md-12 p-0">
          <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                    <div class="row mx-0">
                      <div class="col-md-12">
                        <h4 class="font-weight-bold">Filter Your Results</h4>
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col-md-10 ">
                        <div class="row mx-0">

                          <div class="col-md-12">
                              <!-- filtering starts -->
                              <form>
                                <div class="row m-0">
                                  <div class="col-md-3">
                                    <label>Date</label>
                                    <div class="filter-input">
                                      <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange"   (ngModelChange)="checkRangeType()" required>
                                      </ngx-select>
                                    </div>
                                  </div>
                                  <div class="col-md-3" *ngIf="Rfromdate">

                                    <label>From Date</label>
                                    <div class="filter-input">
                                      <input type="date" class="form-control" placeholder="From Date" id="fromdate" [formControl]="fromdate"
                                        (change)="checkDateRange()">
                                    </div>

                                  </div>
                                  <div class="col-md-3" *ngIf="Rfromdate">
                                    <label>To Date</label>
                                    <div class="filter-input">
                                      <input type="date" class="form-control" placeholder="To Date" id="todate" [formControl]="todate"
                                       (change)="checkDateRange()">
                                    </div>
                                  </div>
                                  <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                                    Date</span>

                                  <div class="col-md-3  mt-4">
                                    <div class="filter-input">
                                      <input type="text" placeholder="PayoutCustomerkeyId" id="PayoutCustomerkeyId" >
                                    </div>
                                  </div>

                                  <div class="col-md-3  mt-4">
                                    <div class="filter-input">
                                      <input type="text" placeholder="AccountNo" id="AccountNo" [formControl]="AccountNo">
                                    </div>
                                  </div>
                                  <div class="col-md-3  mt-4">
                                    <div class="filter-input">
                                      <input type="text" placeholder="AccountHolderName" id="AccountHolderName" [formControl]="AccountHolderName">
                                    </div>
                                  </div>

                                  <div class="col-md-3  mt-4">
                                    <div class="filter-input">
                                      <input type="text" placeholder="MobileNo" id="MobileNo" [formControl]="MobileNo">
                                    </div>
                                  </div>
                                </div>
                              </form>
  <!-- filtering ends -->
                          </div>

                        </div>







                      </div>
                      <div class="col-md-2">
                        <div class="text-right mt-3" *ngIf="!isCustomDateSelected">
                          <button class="search" type="button" id="filtering" (click)="selectedaterange()"
                            matTooltip="New Sale Transaction"> Go</button>
                        </div>

                        <div class="text-right mt-3" *ngIf="isCustomDateSelected">
                          <button class="search" type="button" id="filtering" [disabled]="!isreportsbtnActive"
                            (click)="search()" matTooltip="New Sale Transaction"> Go</button>
                        </div>
                       <!-- <a href="" style="color: #d40055;">Clear</a> -->
                      </div>
                    </div>
           </div>
        </div>
    </div>

    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewCustomerVirtualAccount',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <a class=" edit pl-1 d-inline"
              [routerLink]="['/PayOut/EditCustomerVirtualAccountInfo',{Id: row.Id}]"
                            data-toggle="tooltip" data-placement="top" title="Edit"
                            > <i class="fas fa-edit"></i>
                        </a>
                        <a class="edit pl-1 d-inline"
                        [routerLink]="['/PayOut/DeleteCustomerVirtualAccount',{Id: row.Id}]"
                        data-toggle="tooltip" data-placement="top" title="Delete">
                        <i class="far fa-trash-alt"></i>
                    </a>

            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="Payout Customer AccountKeyId"  [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerAccountKeyId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="PayoutCustomerkeyId">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerkeyId}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="AccountNo">
            <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.AccountNo}}</div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="AccountHolderName">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountHolderName}}
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="City">
            <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.Phone}}</div></ng-template>
          </ngx-datatable-column> -->

          <ngx-datatable-column name="MobileNo">
            <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.MobileNo}}</div></ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Email">
            <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.Email}}</div></ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="DateTime">
            <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div></ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
        </div>
      </div>
      </div>
</div>
</section>


